var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region StudentDetail - Ctor
    ns.StudentDetail = function StudentDetail(reservations, schedules, studentID, activityID, activitySetting) {
        this.reservations = reservations;
        this.initialize(reservations, schedules, studentID, activityID);
        this.activitySetting = activitySetting;
    }
    // #endregion


    // #region StudentDetail - Inheritance

    ns.StudentDetail.prototype = new ns.ScheduleResourceDetailBase();
    ns.StudentDetail.prototype.constructor = ns.StudentDetail;
    ns.StudentDetail.prototype.parent = ns.ScheduleResourceDetailBase.prototype;

    // #endregion

    // #region StudentDetail - Methods

    ns.StudentDetail.prototype.createDayModel = function (reservations, schedules, dayOfWeek, dayName, resourceID, activityID) {
        return new ns.StudentDetailDay(reservations, schedules, dayOfWeek, dayName, resourceID, activityID);
    }

    // #endregion

}(webooker_acivity_models));
